import { Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import { useGetAllProvidersList } from "src/pages/Configuration/Parameters/Others/Providers/api/getAllProvidersList";
import * as Yup from "yup";


const BillingSearchForm = ({ initialValues, onSubmit, onClearForm }: BillingSearchFormProps) => {
  const { t } = useTranslation();
  const getAllProvidersListQuery = useGetAllProvidersList();
  
  const currentYear = new Date().getFullYear();

  const validationSchema= Yup.object({
    year: Yup.string()
      .required('Το πεδίο είναι υποχρεωτικό')
      .matches(/^\d{4}$/, 'Το έτος πρέπει να είναι τετραψήφιος αριθμός')
/*       .test('is-valid-year', 'Το έτος πρέπει να είναι μεταξύ 1900 και του τρέχοντος έτους', (value) => {
        const year = parseInt(value, 10);
        return year >= 1900 && year <= currentYear;
      }) */,
    monthName: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    providerID: Yup.string().required('Το πεδίο είναι υποχρεωτικό')
  })

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
      validationSchema={validationSchema}
    >
      {({ isSubmitting, resetForm }) => (
        <Form>
          <Container fluid className="p-0">
            <Row> 
              <Col xs={6}>
                <FormikTextbox 
                  label={"Έτος"} 
                  fieldName={"year"}
                />
              </Col>

              <Col xs={6}>
                <FormikDropdown
                  label={"Μήνας"}
                  fieldName={"monthName"}
                >
                   <option value="">{t("Επιλέξτε Μήνα")}</option>
                   <option value="Ιανουάριος">{t("Ιανουάριος")}</option>
                   <option value="Φεβρουάριος">{t("Φεβρουάριος")}</option>
                   <option value="Μάρτιος">{t("Μάρτιος")}</option>
                   <option value="Απρίλιος">{t("Απρίλιος")}</option>
                   <option value="Μάιος">{t("Μάιος")}</option>
                   <option value="Ιούνιος">{t("Ιούνιος")}</option>
                   <option value="Ιούλιος">{t("Ιούλιος")}</option>
                   <option value="Αύγουστος">{t("Αύγουστος")}</option>
                   <option value="Σεπτέμβριος">{t("Σεπτέμβριος")}</option>
                   <option value="Οκτώβριος">{t("Οκτώβριος")}</option>
                   <option value="Νοέμβριος">{t("Νοέμβριος")}</option>
                   <option value="Δεκέμβριος">{t("Δεκέμβριος")}</option>
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikDropdown 
                  label={t("Πάροχος")} 
                  fieldName={"providerID"}
                >
                  <option value="">{t("Επιλέξτε Πάροχο")}</option>
                  {getAllProvidersListQuery.data &&
                    getAllProvidersListQuery.data.map((provider) => (
                      <option key={provider.id} value={provider.id}>
                        {provider.description}
                      </option>
                    ))
                  }
                </FormikDropdown>
              </Col>
              
            </Row>

            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={() => {onClearForm(), resetForm()}}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default BillingSearchForm;

type BillingSearchFormProps = {
  initialValues: IBillingSummarySearchForm;
  onSubmit: (
    values: IBillingSummarySearchForm,
    formikHelpers: FormikHelpers<IBillingSummarySearchForm>
  ) => void;
  onClearForm: () => void;
}